module.exports = __webpack_public_path__ + "img/icono-movimientos.4fa450c5.svg";